import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature, IUserAccessSubFeatures} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {IUserAccessFeatureStockTakeSettings} from '../access';

//#region INTERFACE IFeatureStockTakeGeneralSettings
export interface IFeatureStockTakeGeneralSettings extends IUserAccessSubFeatures, IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_STOCK_TAKE_GENERAL_SETTINGS_DEFAULT
export const _FEATURE_STOCK_TAKE_GENERAL_SETTINGS_DEFAULT: Readonly<IFeatureStockTakeGeneralSettings & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockTakeGeneral,
  feature: NavigationPageEnum.StockTakeGeneral,
  ref: SettingsReferenceEnum.featureStockTakeGeneral,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureStockTake
export interface IFeatureStockTake extends IUserAccessFeature, Object {
  crudAccess: { [storeId: string]: IUserAccessFeatureStockTakeSettings };
}

//#endregion

//#region CONST _FEATURE_STOCK_TAKE_DEFAULT
export const _FEATURE_STOCK_TAKE_DEFAULT: Readonly<IFeatureStockTake & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockTake,
  feature: NavigationPageEnum.StockTake,
  ref: SettingsReferenceEnum.featureStockTake,
  standalone: false,
  subFeatures: [
    {..._FEATURE_STOCK_TAKE_GENERAL_SETTINGS_DEFAULT},
  ],
  crudAccess: {},
};
//#endregion
